module.exports = __webpack_public_path__ + "static/media/unagi_hot.36e46642.webp";